<template>
  <div>
    <Sidebar />
    <div class="content">
      <NavBar />
      <main>
        <div class="header">
          <div class="left">
            <h1>Projeto - Solar</h1>
          </div>
            <div style="display:flex; gap:8px; align-items:center;">
              <button class="btn btn-primary btn-all mr-3" @click="openReportModal">
                <i class='bx bx-download'></i>
                Gerar PDF
              </button>
            </div>
        </div>

        <!-- Abas -->
        <div class="tabs-container" style="display: flex; gap: 10px; margin-bottom: 20px; border-bottom: 2px solid #eee; padding-bottom: 10px;">
          <button 
            :class="['tab-button', { active: activeTab === 'ativos' }]"
            @click="activeTab = 'ativos'"
            style="padding: 10px 20px; border: none; background: none; cursor: pointer; font-weight: 500; border-bottom: 3px solid transparent;"
          >
            Ativos
          </button>
          <button 
            :class="['tab-button', { active: activeTab === 'arquivados' }]"
            @click="activeTab = 'arquivados'"
            style="padding: 10px 20px; border: none; background: none; cursor: pointer; font-weight: 500; border-bottom: 3px solid transparent;"
          >
            Arquivados
          </button>
        </div>

        <!-- Botões de Filtro -->
        <div v-show="role == 2" class="filtros-topo" style="display: flex; gap: 10px; margin-bottom: 20px;">
          <button class="btn btn-primary btn-all mr-3" @click="showFilterModal = true">
            <i class="bx bx-filter"></i>
          </button>

          <button class="btn btn-primary btn-all mr-3" @click="sortByDate">Data de criação</button>
          <button class="btn btn-primary btn-all mr-3" @click="sortByStatus">Situação</button>
          <button class="btn btn-secondary" @click="clearFilters">Limpar</button>
        </div>

        <!-- Modal de Filtro -->
        <div v-if="showFilterModal" class="modal-backdrop">
          <div class="modal-card">
            <div class="modal-card-header">
              <h5>Filtros</h5>
              <button class="modal-close" @click="showFilterModal = false">×</button>
            </div>

            <div class="modal-card-body">
              <div class="row">
                <div class="col-12 col-sm-6">
                  <div class="form-input mb-3">
                    <label>Data de Início</label>
                    <input type="date" v-model="filters.startDate" class="form-control" />
                  </div>
                </div>
                <div class="col-12 col-sm-6">
                  <div class="form-input mb-3">
                    <label>Data de Fim</label>
                    <input type="date" v-model="filters.endDate" class="form-control" />
                  </div>
                </div>
                <div v-if="activeTab === 'ativos'" class="col-12 col-sm-6">
                  <div class="form-input mb-3">
                    <label>Situação</label>
                    <select v-model="filters.status" class="form-control" >
                      <option value="">Todas</option>
                      <option v-for="(label, key) in statusOptions" :key="key" :value="key">
                        {{ label }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-12 col-sm-6">
                  <div class="form-input mb-3">
                    <label>Pagamento</label>
                    <select v-model="filters.paymentType" class="form-control" >
                      <option value="">Todos</option>
                      <option v-for="(label, key) in paymentOptions" :key="key" :value="key">
                        {{ label }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <div class="modal-card-footer">
              <button @click="showFilterModal = false" class="btn btn-outline-secondary">Cancelar</button>
              <button @click="applyFilters" class="btn btn-roxo">Filtrar</button>
            </div>
          </div>
        </div>

        <!-- Modal de Escolha de Relatorio -->
        <div v-if="showReportModal" class="modal-backdrop">
          <div class="modal-card">
            <div class="modal-card-header">
              <h5>Gerar Relatório</h5>
              <button class="modal-close" @click="showReportModal = false">×</button>
            </div>
            <div class="modal-card-body">
              <div class="form-input mb-3">
                <label>Escopo</label>
                <select v-model="tempReportScope" class="form-control">
                  <option value="all">Todos</option>
                  <option value="ativos">Apenas Ativos</option>
                  <option value="arquivados">Apenas Arquivados</option>
                </select>
              </div>
            </div>
            <div class="modal-card-footer">
              <button @click="showReportModal = false" class="btn btn-outline-secondary">Cancelar</button>
              <button @click="confirmReportScope" class="btn btn-primary btn-all">Gerar</button>
            </div>
          </div>
        </div>

        <!-- Aba Ativos -->
        <div v-if="activeTab === 'ativos'" class="bottom-data">
          <div class="orders">
            <div class="header">
              <i class="bx bx-message-square-dots"></i>
              <h3>Listagem</h3>
              <router-link to="/projetos/solar/adicionar" data-bs-placement="right"
                tooltip-bs-title="Adicionar Projeto">
                <i class="bx bx-plus-circle icon-success"></i>
              </router-link>
            </div>
            <table v-if="role != 2">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Nome</th>
                  <th>Criação</th>
                  <th>Situação</th>
                  <th>Pagamento</th>
                  <th>Ação</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="project in projects" :key="project.id">
                  <td>{{ project.id }}</td>
                  <td>{{ project.project_name }}</td>
                  <td>{{ formatDate(0, project.created_at) }} </td>
                  <td>
                    <span class="status" :class="getStatusClass(project.id_state)">
                      {{ getStatusText(project.id_state) }}
                    </span>
                  </td>
                  <td>
                    <span class="status" :class="statusPay(project.payment_status)">
                      {{ getStatusPay(project.payment_status) }}
                    </span>
                  </td>
                  <td class="actions-icon">
                    <router-link :to="{ name: 'project-manager', params: { projeto: project.id } }">
                      <span data-bs-toggle="tooltip" tooltip-bs-title="Ver detalhes do projeto"
                        class="bx bx-detail ml-5 mr-5 icon-primary">
                      </span>
                    </router-link>
                  </td>
                </tr>
              </tbody>
            </table>
            <div v-show="role == 2" v-for="(item, index) in filteredProjects" :key="index" class="accordion-item">
              <button @click="toggle(index)" class="accordion-header">
                {{ item.full_name }}
              </button>
              <div v-show="activeIndex === index" class="accordion-content">
                <table>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Nome</th>
                      <th>ID Geração</th>
                      <th>Criação</th>
                      <th>Situação</th>
                      <th>Pagamento</th>
                      <th>Ação</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="project in item.listProject" :key="project.id">
                      <td>{{ project.id }}</td>
                      <td>{{ project.project_name }}</td>
                      <td>{{ project.id_generation }}</td>
                      <td>{{ formatDate(0, project.created_at) }} </td>
                      <td>
                        <span class="status" :class="getStatusClass(project.id_state)">
                          {{ getStatusText(project.id_state) }}
                        </span>
                      </td>
                      <td>
                        <span class="status" :class="statusPay(project.payment_status)">
                          {{ getStatusPay(project.payment_status) }}
                        </span>
                      </td>
                      <td class="actions-icon">
                        <router-link :to="{ name: 'project-manager', params: { projeto: project.id } }">
                          <span data-bs-toggle="tooltip" tooltip-bs-title="Ver detalhes do projeto"
                            class="bx bx-detail ml-5 mr-5 icon-primary">
                          </span>
                        </router-link>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <!-- Aba Arquivados -->
        <div v-else class="bottom-data">
          <div class="orders">
            <div class="header">
              <i class="bx bx-message-square-dots"></i>
              <h3>Listagem de Arquivados</h3>
            </div>
            <div v-if="archivedProjects.length === 0" class="empty-state">
              <p>Nenhum projeto arquivado encontrado.</p>
            </div>
            <template v-else>
              <table v-if="role != 2">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Nome</th>
                  <th>Criação</th>
                  <th>Situação</th>
                  <th>Pagamento</th>
                  <th>Ação</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="project in archivedProjects" :key="project.id">
                  <td>{{ project.id }}</td>
                  <td>{{ project.project_name }}</td>
                  <td>{{ formatDate(0, project.created_at) }} </td>
                  <td>
                    <span class="status" :class="getStatusClass(project.id_state)">
                      {{ getStatusText(project.id_state) }}
                    </span>
                  </td>
                  <td>
                    <span class="status" :class="statusPay(project.payment_status)">
                      {{ getStatusPay(project.payment_status) }}
                    </span>
                  </td>
                  <td class="actions-icon">
                    <router-link :to="{ name: 'project-manager', params: { projeto: project.id } }">
                      <span data-bs-toggle="tooltip" tooltip-bs-title="Ver detalhes do projeto"
                        class="bx bx-detail ml-5 mr-5 icon-primary">
                      </span>
                    </router-link>
                  </td>
                </tr>
              </tbody>
            </table>
            <div v-show="role == 2" v-for="(item, index) in filteredArchivedProjects" :key="index" class="accordion-item">
              <button @click="toggleArchived(index)" class="accordion-header">
                {{ item.full_name }}
              </button>
              <div v-show="activeArchivedIndex === index" class="accordion-content">
                <table>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Nome</th>
                      <th>ID Geração</th>
                      <th>Criação</th>
                      <th>Situação</th>
                      <th>Pagamento</th>
                      <th>Ação</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="project in item.listProject" :key="project.id">
                      <td>{{ project.id }}</td>
                      <td>{{ project.project_name }}</td>
                      <td>{{ project.id_generation }}</td>
                      <td>{{ formatDate(0, project.created_at) }} </td>
                      <td>
                        <span class="status" :class="getStatusClass(project.id_state)">
                          {{ getStatusText(project.id_state) }}
                        </span>
                      </td>
                      <td>
                        <span class="status" :class="statusPay(project.payment_status)">
                          {{ getStatusPay(project.payment_status) }}
                        </span>
                      </td>
                      <td class="actions-icon">
                        <router-link :to="{ name: 'project-manager', params: { projeto: project.id } }">
                          <span data-bs-toggle="tooltip" tooltip-bs-title="Ver detalhes do projeto"
                            class="bx bx-detail ml-5 mr-5 icon-primary">
                          </span>
                        </router-link>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            </template>
          </div>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import Cookie from 'js-cookie';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import logoInoveng from "@/assets/images/logo_inoveng.png";
import NavBar from '@/components/NavBar.vue';
import Sidebar from '@/components/SideBar.vue';

export default {
  components: {
    NavBar,
    Sidebar,
  },
  data() {
    return {
      role: this.$store.state.role,
      activeTab: 'ativos',
      showFilterModal: false,
      filters: {
        startDate: '',
        endDate: '',
        status: '',
        paymentType: ''
      },
      projects: [],
      filteredProjects: [],
      archivedProjects: [],
      filteredArchivedProjects: [],
      rawProjects: [],
      reportScope: 'all',
      showReportModal: false,
      tempReportScope: 'all',
      activeIndex: null,
      activeArchivedIndex: null,
      statusOptions: {
        1: 'Aberto',
        2: 'Em progresso',
        3: 'Protocolado',
        4: 'Em Parecer de Acesso',
        5: 'Obra em andamento',
        6: 'Aprovado',
        7: 'Vistoria solicitada',
        8: 'Finalizado',
        9: 'Cancelado',
        10: 'Aguardando Solicitação de Vistoria'
      },
      paymentOptions: {
        1: 'Aguardando Pagamento 1/2',
        2: 'Pagamento Confirmado 1/2',
        3: 'Aguardando pagamento RRT',
        4: 'Pagamento RRT Confirmado',
        5: 'Aguardando Pagamento 2/2',
        6: 'Pago'
      }
    };
  },
  methods: {
    toggle(index) {
      this.activeIndex = this.activeIndex === index ? null : index;
    },
    toggleArchived(index) {
      this.activeArchivedIndex = this.activeArchivedIndex === index ? null : index;
    },
    clearFilters() {
      this.filters = {
        startDate: '',
        endDate: '',
        status: '',
        paymentType: ''
      };
      this.filteredProjects = this.projects;
    },
    applyFilters() {
      this.showFilterModal = false;
      const start = this.filters.startDate ? new Date(this.filters.startDate) : null;
      const end = this.filters.endDate ? new Date(this.filters.endDate + 'T23:59:59') : null;
      const status = this.filters.status ? [String(this.filters.status)] : [];
      const payment = this.filters.paymentType ? [String(this.filters.paymentType)] : [];

      const result = this.projects.map(group => {
        const filteredList = group.listProject.filter(proj => {
          const createdAt = new Date(proj.created_at);
          const inRange = (!start || createdAt >= start) && (!end || createdAt <= end);
          const matchStatus = !status.length || status.includes(String(proj.id_state));
          const matchPay = !payment.length || payment.includes(String(proj.payment_status));
          return inRange && matchStatus && matchPay;
        });
        return Object.assign({}, group, { listProject: filteredList });
      }).filter(group => group.listProject.length > 0);

      this.filteredProjects = JSON.parse(JSON.stringify(result));

    },
    openReportModal() {
      this.tempReportScope = this.reportScope || 'all';
      this.showReportModal = true;
    },
    confirmReportScope() {
      this.reportScope = this.tempReportScope || 'all';
      this.showReportModal = false;
      this.generatePdf();
    },
    sortByDate() {
      this.filteredProjects = this.filteredProjects.map(group => {
        const sortedList = [...group.listProject].sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
        return { ...group, listProject: sortedList };
      });
    },
    sortByStatus() {
      this.filteredProjects = this.filteredProjects.map(group => {
        const sortedList = [...group.listProject].sort((a, b) => a.id_state - b.id_state);
        return { ...group, listProject: sortedList };
      });
    },
    formatDate(type, date) {
      if (!date) return '';
      const d = new Date(date);
      return `${d.getDate().toString().padStart(2, '0')}/${(d.getMonth() + 1).toString().padStart(2, '0')}/${d.getFullYear()}`;
    },
    getStatusClass(status) {
      switch (status) {
        case 1:
          return 'dark-grey';
        case 2:
          return 'light-warning';
        case 3:
          return 'pending';
        case 4:
          return 'warning';
        case 5:
          return 'danger';
        case 6:
          return 'success';
        case 7:
        case 10:
          return 'primary';
        case 8:
          return 'completed';
        case 9:
          return 'cancelled';
      }
    },
    getTypeProject(status) {
      switch (status) {
        case '1':
          return 'Solar';
        case '2':
          return 'Medição Agrupada';
        case '3':
          return 'Eletrico Predial';
        case '4':
          return 'Subestação';
      }
    },
    getStatusText(status) {
      switch (status) {
        case 1:
          return 'Aberto';
        case 2:
          return 'Em progresso';
        case 3:
          return 'Protocolado';
        case 4:
          return 'Em Parecer de Acesso';
        case 5:
          return 'Obra em andamento';
        case 6:
          return 'Aprovado';
        case 7:
          return 'Vistoria solicitada';
        case 8:
          return 'Finalizado';
        case 9:
          return 'Cancelado';
        case 10:
          return 'Aguardando Solicitação de Vistoria'
      }
    },
    statusPay(status) {
      switch (status) {
        case 1:
          return 'warning';
        case 2:
          return 'light-warning';
        case 3:
          return 'warning';
        case 4:
          return 'light-warning';
        case 5:
          return 'pending';
        case 6:
          return 'success';
      }
    },
    getStatusPay(status) {
      switch (status) {
        case 1:
          return 'Aguardando Pagamento 1/2';
        case 2:
          return 'Pagamento Confirmado 1/2';
        case 3:
          return 'Aguardando pagamento RRT';
        case 4:
          return 'Pagamento RRT Confirmado';
        case 5:
          return 'Aguardando Pagamento 2/2';
        case 6:
          return 'Pago';
      }
    },
    load() {
      return this.$http
        .get("user/projects/list/1", {
          headers: {
            Authorization: "Bearer " + Cookie.get("_token"),
          },
        })
        .then((response) => {
          const data = response.data.projects || [];
          this.rawProjects = JSON.parse(JSON.stringify(data));
          if (this.role == 2) {
            const groups = data;
            this.projects = groups
              .map((g) => ({ ...g, listProject: (g.listProject || []).filter(p => p.archived != 1) }))
              .filter(g => g.listProject && g.listProject.length > 0);
            this.filteredProjects = JSON.parse(JSON.stringify(this.projects));
            this.archivedProjects = groups
              .map((g) => ({ ...g, listProject: (g.listProject || []).filter(p => p.archived == 1) }))
              .filter(g => g.listProject && g.listProject.length > 0);
            this.filteredArchivedProjects = JSON.parse(JSON.stringify(this.archivedProjects));
          } else {
            this.projects = data.filter(p => p.archived != 1);
            this.filteredProjects = this.projects;
            this.archivedProjects = data.filter(p => p.archived == 1);
            this.filteredArchivedProjects = this.archivedProjects;
          }
        })
        .catch(() => {
          alert("Erro ao carregar projetos");
        });
    },
    buildRows(projects) {
      return projects.map((project) => ([
        project.id,
        project.project_name,
        this.formatDate(0, project.created_at),
        this.getStatusText(project.id_state),
        this.getStatusPay(project.payment_status)
      ]));
    },
    buildRowsWithGeneration(projects) {
      return projects.map((project) => ([
        project.id,
        project.project_name,
        project.id_generation,
        this.formatDate(0, project.created_at),
        this.getStatusText(project.id_state),
        this.getStatusPay(project.payment_status)
      ]));
    },
    addSectionTitle(doc, title, startY) {
      doc.setFontSize(12);
      doc.setTextColor(20);
      doc.text(title, 40, startY);
      return startY + 10;
    },
    loadLogoDataUrl() {
      return new Promise((resolve) => {
        const img = new Image();
        img.onload = () => {
          const canvas = document.createElement('canvas');
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0);
          resolve(canvas.toDataURL('image/png'));
        };
        img.onerror = () => resolve(null);
        img.src = logoInoveng;
      });
    },
    async generatePdf() {
      // ensure data is loaded
      if ((!this.rawProjects || this.rawProjects.length === 0) && (!this.projects || this.projects.length === 0)) {
        await this.load();
      }

      let dataForReport = [];
      if (this.role == 2) {
        if (this.reportScope === 'all') {
          dataForReport = this.rawProjects || this.filteredProjects;
        } else if (this.reportScope === 'ativos') {
          dataForReport = this.filteredProjects;
        } else {
          dataForReport = this.filteredArchivedProjects;
        }
      } else {
        if (this.reportScope === 'all') {
          dataForReport = (this.rawProjects && this.rawProjects.length) ? this.rawProjects : [...(this.projects||[]), ...(this.archivedProjects||[])];
        } else if (this.reportScope === 'ativos') {
          dataForReport = this.projects;
        } else {
          dataForReport = this.archivedProjects;
        }
      }

      if (!dataForReport || dataForReport.length === 0) {
        alert("Nenhum projeto encontrado para gerar o relatório.");
        return;
      }

      const doc = new jsPDF({
        orientation: 'landscape',
        unit: 'pt',
        format: 'a4'
      });

      const logoDataUrl = await this.loadLogoDataUrl();
      const now = new Date();
      const title = 'Relatorio de Projetos - Solar';
      const subtitle = `Gerado em ${this.formatDate(0, now)}`;
      const headerHeight = logoDataUrl ? 70 : 50;

      const drawHeader = () => {
        if (logoDataUrl) {
          doc.addImage(logoDataUrl, 'PNG', 40, 18, 90, 30);
        }
        doc.setFontSize(16);
        doc.setTextColor(20);
        doc.text(title, 140, 36);
        doc.setFontSize(10);
        doc.setTextColor(80);
        doc.text(subtitle, 140, 52);
      };

      drawHeader();
      let currentY = headerHeight + 10;

      if (this.role == 2) {
        const head = [[
          '#',
          'Nome',
          'ID Geracao',
          'Criacao',
          'Situacao',
          'Pagamento'
        ]];
        dataForReport.forEach((group) => {
          currentY = this.addSectionTitle(doc, `Integrador: ${group.full_name}`, currentY);
          autoTable(doc, {
            head,
            body: this.buildRowsWithGeneration(group.listProject || []),
            startY: currentY,
            margin: { top: headerHeight },
            theme: 'grid',
            styles: { fontSize: 9, cellPadding: 6 },
            headStyles: { fillColor: [230, 120, 23] },
            rowPageBreak: 'avoid',
            didDrawPage: drawHeader
          });
          currentY = doc.lastAutoTable.finalY + 18;
        });
      } else {
        const head = [[
          '#',
          'Nome',
          'Criacao',
          'Situacao',
          'Pagamento'
        ]];
        autoTable(doc, {
          head,
          body: this.buildRows(Array.isArray(dataForReport) ? dataForReport : []),
          startY: currentY,
          margin: { top: headerHeight },
          theme: 'grid',
          styles: { fontSize: 9, cellPadding: 6 },
          headStyles: { fillColor: [230, 120, 23] },
          rowPageBreak: 'avoid',
          didDrawPage: drawHeader
        });
      }

      doc.save('relatorio-projetos-solar.pdf');
    }
  },
  created() {
    this.load();
  },
};
</script>

<style>
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1100;
}

.modal-card {
  background: #ffffff;
  width: 560px;
  max-width: 95%;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(16, 24, 40, 0.15);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.modal-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #f1f1f1;
}

.modal-card-header h5 {
  margin: 0;
  font-size: 16px;
  color: #222;
}

.modal-close {
  background: transparent;
  border: none;
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
  color: #666;
}

.modal-card-body {
  padding: 18px 20px;
}

.modal-card-footer {
  padding: 14px 20px;
  border-top: 1px solid #f6f6f6;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.form-group {
  margin-bottom: 15px;
  display: flex;
  flex-direction: column;
}

.btn-roxo {
  background: linear-gradient(90deg,#3c1053 0%,#5b1a73 100%);
  color: #fff;
  border: none;
  padding: 8px 18px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
  box-shadow: 0 6px 16px rgba(60,16,83,0.12);
}
.btn-roxo:hover { filter: brightness(0.95); }

.tab-button {
  color: #666;
  transition: all 0.3s ease;
}

.tab-button.active {
  color: #e67817;
  border-bottom-color: #e67817 !important;
}

.empty-state {
  padding: 40px;
  text-align: center;
  color: #999;
}
</style>
